import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    counter: 0,
    menuState: true,
    optionActive: 0,
    usuario: null,
    contrasenia:null,
    login:false,
    visitante:""

  },
  mutations: {
    // nombre de la funcion y variable
    // estado a la que modifica el tontador 
    CLOSEMENU(state) {
      state.menuState = false;
    },
    UPDATEMENU(state) {
      state.menuState = !state.menuState;
    },
    UPDATEVISITANTE(state, visitante) {
      state.visitante = visitante;
    },
    LOGOUT(state) {
      state.login = !state.login;
      state.usuario = null;
      state.contrasenia = null;
    },
    LOGIN(state, user) {
      state.login = !state.login;
      state.usuario = user[0];
      state.contrasenia= user[1];

    },
    UPDATEOPTIONACTIVE(state, opc) {
      state.optionActive = opc;
    },
    RESETOPTION() {
      state.optionActive = 0;
    },

    UPDATETITLE(state, title) {
      state.title = title;
    }
  }
})


export default store








// WEBPACK FOOTER //
// ./src/store.js